import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft, FaExternalLinkAlt, FaClock, FaTag } from 'react-icons/fa';

const POSTS = [
  {
    id: 1,
    title: 'Naukri vs LinkedIn vs JobxBharat: Which Platform is Best for Freshers in India 2025–26?',
    excerpt: 'A detailed comparison of the top job platforms in India — breaking down features, reach, and real value for fresh graduates entering the job market.',
    tags: ['Platform Comparison', 'Freshers', 'Job Seeking'],
    readTime: '6 min read',
    href: 'https://medium.com/@sboruah878/naukri-vs-linkedin-vs-jobxbharat-which-platform-is-best-for-freshers-in-india-2025-26-b6ae2eafbcc0',
    accent: 'bg-brand-purple',
    accentText: 'text-brand-purple',
    accentBg: 'bg-secondary-50',
  },
  {
    id: 2,
    title: 'From Campus to Career: Understanding Today\'s Job Reality',
    excerpt: 'The gap between college education and real-world employment is widening. Here\'s an honest look at what freshers face — and how to navigate it.',
    tags: ['Career Advice', 'Students', 'Campus Life'],
    readTime: '5 min read',
    href: 'https://medium.com/@sboruah878/from-campus-to-career-understanding-todays-job-reality-c434daab4c3d',
    accent: 'bg-brand-saffron',
    accentText: 'text-brand-saffron',
    accentBg: 'bg-orange-50',
  },
  {
    id: 3,
    title: 'Top 5 Problems TPOs Face During Placement Season — and the Tech Solutions That Fix Them',
    excerpt: 'From managing hundreds of student profiles to coordinating campus drives, placement officers are overwhelmed. Discover the tech tools changing the game.',
    tags: ['College Placement', 'TPO', 'EdTech'],
    readTime: '7 min read',
    href: 'https://medium.com/@sboruah878/top-5-problems-tpos-face-during-placement-season-and-the-tech-solutions-that-fix-them-55cef4c2f61b',
    accent: 'bg-brand-green',
    accentText: 'text-brand-green',
    accentBg: 'bg-green-50',
  },
  {
    id: 4,
    title: 'How to Set Up a Fully Automated Campus Recruitment Drive in 2025: Step-by-Step',
    excerpt: 'A practical guide for TPOs and placement teams to automate eligibility filtering, student notifications, and recruiter coordination — end to end.',
    tags: ['Recruitment', 'Campus', 'Automation'],
    readTime: '8 min read',
    href: 'https://medium.com/@sboruah878/how-to-set-up-a-fully-automated-campus-recruitment-drive-in-2025-step-by-step-439b57610a55',
    accent: 'bg-ink-900',
    accentText: 'text-ink-700',
    accentBg: 'bg-gray-50',
  },
];

export default function Blogs() {
  const navigate = useNavigate();

  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="min-h-screen bg-paper text-ink-900">

      {/* Top bar */}
      <header className="sticky top-0 z-40 bg-white/90 backdrop-blur-md border-b border-gray-100">
        <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
          <button
            onClick={() => navigate('/')}
            className="flex items-center gap-2 text-sm font-semibold text-ink-500
                       hover:text-ink-900 transition-colors"
          >
            <FaArrowLeft /> Back to Home
          </button>
          <span className="font-brand font-black text-lg text-ink-900">Jobx<span className="text-brand-saffron">Bharat</span></span>
        </div>
      </header>

      <div className="max-w-5xl mx-auto px-6 py-16">

        {/* Hero */}
        <div className="mb-14 text-center">
          <span className="text-xs font-black tracking-widest uppercase text-brand-purple mb-3 block">
            Blog
          </span>
          <h1 className="font-display font-black text-4xl md:text-5xl text-ink-900 mb-4 tracking-tight">
            Insights from Jobx<span className="text-brand-saffron">Bharat</span>
          </h1>
          <p className="text-ink-500 text-lg max-w-2xl mx-auto leading-relaxed">
            Real talk on jobs, campus placements, hiring trends, and building a career in India.
          </p>
        </div>

        {/* Posts grid */}
        <div className="grid md:grid-cols-2 gap-6">
          {POSTS.map(post => (
            <a
              key={post.id}
              href={post.href}
              target="_blank"
              rel="noopener noreferrer"
              className="group block p-7 rounded-3xl bg-white border border-gray-100
                         hover:shadow-glass-lg hover:-translate-y-1 transition-all duration-200"
            >
              {/* Accent bar */}
              <div className={`w-10 h-1 rounded-full ${post.accent} mb-5`} />

              <h2 className="font-display font-black text-lg text-ink-900 leading-snug mb-3
                             group-hover:text-brand-purple transition-colors">
                {post.title}
              </h2>

              <p className="text-sm text-ink-500 leading-relaxed mb-5 line-clamp-3">
                {post.excerpt}
              </p>

              {/* Meta row */}
              <div className="flex items-center justify-between">
                <div className="flex flex-wrap gap-2">
                  {post.tags.map(tag => (
                    <span
                      key={tag}
                      className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-full
                                  text-xs font-semibold ${post.accentBg} ${post.accentText}`}
                    >
                      <FaTag className="text-[10px]" />
                      {tag}
                    </span>
                  ))}
                </div>
                <div className="flex items-center gap-1.5 text-xs text-ink-300 shrink-0 ml-3">
                  <FaClock />
                  {post.readTime}
                </div>
              </div>

              {/* Read link */}
              <div className={`mt-5 flex items-center gap-2 text-xs font-black ${post.accentText}
                              opacity-0 group-hover:opacity-100 transition-opacity`}>
                Read on Medium <FaExternalLinkAlt />
              </div>
            </a>
          ))}
        </div>

        {/* More coming soon banner */}
        <div className="mt-14 p-8 rounded-3xl bg-ink-900 text-white text-center">
          <p className="font-display font-black text-xl mb-2">More posts coming soon</p>
          <p className="text-white/60 text-sm">
            Follow us on{' '}
            <a
              href="https://medium.com/@sboruah878"
              target="_blank"
              rel="noopener noreferrer"
              className="text-brand-saffron hover:underline font-semibold"
            >
              Medium
            </a>
            {' '}to get notified when we publish new articles.
          </p>
        </div>
      </div>

      <footer className="py-8 border-t border-gray-100 text-center text-xs text-ink-300 bg-white">
        © {new Date().getFullYear()} Jobx<span className="text-brand-saffron">Bharat</span> · All rights reserved ·{' '}
        <a href="/privacy-policy" className="hover:text-brand-purple">Privacy Policy</a>
        {' '}·{' '}
        <a href="/terms-and-conditions" className="hover:text-brand-purple">Terms & Conditions</a>
      </footer>
    </div>
  );
}
